import React, { useEffect, useState } from "react";
import CatalogTableC from "../../components/Catalogs/CatalogTableC";
import PaginatedTable from "../../components/Organismos/Table/PaginatedTable";
import ShapeEdit from "../../components/Atomos/Icons/ShapeEdit";
import useDataLoader2 from "../../hooks/useDataLoader2";
import { defaultPageSize } from "../../utils/const";
import Filters, {
  IFilterData,
} from "../../components/Catalogs/Filters/Filters";
import PersistentLink from "../../components/Moleculas/PersistentLink";
import { IGuestSpeaker } from "../../interfaces/models/IGuestSpeaker";
import { UseCountryList } from "../../hooks/Catalogs";
import { getCompanies } from "../../Services/Company";
import { ICompany } from "../../interfaces/models/ICompany";
import { exportAllDataLoader2 } from "../../utils/exportAllDataLoader2";

const GuestSpeaker: React.FC = () => {
  const fields = ["id", "honorary", "firstName", "middleInitial", "lastName", "suffix", "title", "unlistedTitle", "company", "email", "webPage", "address", "city", "stateProvince", "country", "phone", "fax", "assistantName", "assistantEmail", "contactType", "linkedinUrl", "xUrl", "facebookUrl", "instagramUrl", "photo", "profile", "_ts", "companyName", "countryName"];
  const endpoint = "/guestSpeaker";
  const { countryData } = UseCountryList();

  const [companiesData, setCompaniesData] = useState<ICompany[]>([]);
  useEffect(() => {
    getCompanies().then((companies) => setCompaniesData(companies));
  }, []);
  useEffect(() => {
    console.log(companiesData);
  }, [companiesData]);

  const {
    data,
    totalCount,
    fetchData,
    setFilter,
    sort,
    setSort,
    pagination,
    setPagination,
    filter,
    inputFilters,
    setInputFilters,
  } = useDataLoader2<any>({
    endpoint,
    defaultPageSize,
    fields,
    defaultSorting: { field: "firstName", order: "asc" },
  });

  const columnsDef = React.useMemo(() => [
    {
      id: "count",
      header: "#",
      enableSorting: false,
      cell: ({ rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <p>
          {" "}
          {rowIndex +
            1 +
            pagination.pageIndex * pagination.pageSize}{" "}
        </p>
      ),
    },
    { id: "name", header: "Name" },
    { id: "title", header: "Title" },
    { id: "company", header: "Company" },
    { id: "email", header: "Email" },
    { id: "address", header: "Address" },
    { id: "city", header: "City" },
    { id: "stateProvince", header: "State/Province" },
    { id: "country", header: "Country" },
    { id: "phone", header: "Phone" },
    { id: "assistantName", header: "Assistant Name" },
    { id: "assistantEmail", header: "Assistant Email" },
    { id: "contactType", header: "Contact Type" },
    {
      id: "edit",
      header: "Edit",
      enableSorting: false,
      cell: ({ row }: { rowIndex: number; row: any; value: any }) => (
        <PersistentLink
          className="edit"
          to={`Edit/${row.id}`}
          state={row}
          persistingData={{
            pagination,
            sort,
            filter,
            inputFilters,
          }}
        >
          Edit{" "}
          <div className="editsvg">
            <ShapeEdit />
          </div>{" "}
        </PersistentLink>
      ),
    },
  ], [pagination.pageIndex, pagination.pageSize, sort, filter, inputFilters]);

  const filtersData: IFilterData[] = React.useMemo(
    () => [
      {
        name: "Name",
        type: "text",
        comparison: "CONTAINS",
        
      },
      {
        name: "Company",
        type: "multiselect",
        objectData: companiesData?.map((company: any) => ({
          id: company.id,
          name: company.name,
        })),
        comparison: "EQUAL",
      },
      {
        name: "Country",
        type: "multiselect",
        objectData: countryData?.map((country: any) => ({
          id: country.id,
          name: country.name,
        })),
        comparison: "EQUAL",
      },
      {
        name: "Email",
        type: "text",
        comparison: "CONTAINS",
      },
    ],
    [companiesData, countryData]
  );

  const formatData = (data: IGuestSpeaker[]) => {
    return data.map((d: IGuestSpeaker) => {
      return {
        ...d,
        name: `${d.firstName} ${d.lastName}`,
        title: d.title ? d.title : d.unlistedTitle,
        company: d.companyName,
        country: d.countryName,
      };
    });
  };

  return (
    <>
      <CatalogTableC
        title={`Guest Speaker Catalog`}
        catalogName={"GUEST SPEAKERS"}
        catalogShortName={"GUEST SPEAKER"}
        route={"GuestSpeaker"}
        totalCount={totalCount}
      >
        <Filters
          filtersData={filtersData}
          filterValues={inputFilters}
          setFilterValues={setInputFilters}
          Search={() => fetchData()}
          clearSelections={() => fetchData(true)}
          setValueForQuery={setFilter}
        />
        <PaginatedTable
          data={data || []}
          columnsDef={columnsDef}
          sorting={sort}
          formatData={formatData}
          onSortingChange={setSort}
          totalCount={totalCount || 0}
          pagination={pagination}
          onPaginationChange={setPagination}
          endpoint={endpoint}
          onExportAll={() =>
            exportAllDataLoader2<any>({
              endpoint,
              filter,
              sort,
              pageSize: 1000,
              fields,
            })
          }
        />
      </CatalogTableC>
    </>
  );
};

export default GuestSpeaker;
